<template>
  <div :class="getRightSideClasses">
    <NoPartner
      v-show="!remoteParticipantData"
      :remoteParticipantData="remoteParticipantData"
      :remoteParticipantScreenData="remoteParticipantScreenData"
      :themeCoreColor="themeCoreColor"
      :themeBorderColor="themeBorderColor"
      :themeLightBackgroundColor="themeLightBackgroundColor"
      @rebootWithNewSessionID="rebootWithNewSessionID"
    />

    <!-- Ensure partner has video turned on, but also one's own -->
    <div v-show="partnerStatesInitialized && remoteParticipantData && partnerVideo && localVideoTrack" id="remote-video" :class="getRemoteVideoClasses"></div>

    <!-- If no video, show alternate -->
    <div
      v-show="partnerStatesInitialized && remoteParticipantData && !partnerVideo && partnerVideo !== null && localVideoTrack && !partnerLeft && !partnerDisconnected && ready && sessionLoaded"
      class="partnerCameraOff"
      :class="getRemoteVideoClasses"
    >
      <div class="partnerCameraOffTitle">Your partner will not be able to see your video feed while their camera is off.</div>
    </div>

    <div v-show="!localVideoTrack && ready && sessionLoaded" class="partnerCameraOff" :class="getRemoteVideoClasses">
      <div class="partnerCameraOffTitle">You won't be able to see your partner until you turn on your video.</div>
      <div class="partnerCameraOffText">Remember that camera is strictly mandatory on Cofocus. Not doing so for an extended period of time can lead to an automatic ban from using Cofocus.</div>
    </div>

    <div v-show="remoteParticipantScreenData" id="remoteScreenshare" :class="getRemoteScreenshareClasses"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import NoPartner from "../SessionComponents/NoPartner";
import { getLayoutElementClasses } from "../SessionHelpers/layout";

export default {
  name: "RemoteParticipant",
  components: {
    NoPartner,
  },
  computed: {
    ...mapState({
      partnerStatesInitialized: (state) => state.room.partnerStatesInitialized,
      partnerVideo: (state) => state.room.partnerVideo,
      localVideoTrack: (state) => state.room.localVideoTrack,
      remoteParticipantData: (state) => state.room.remoteParticipantData,
      remoteParticipantScreenData: (state) => state.room.remoteParticipantScreenData,
      themeCoreColor: (state) => state.room.themeCoreColor,
      themeBorderColor: (state) => state.room.themeBorderColor,
      themeLightBackgroundColor: (state) => state.room.themeLightBackgroundColor,
      remoteVideoConfig: (state) => state.preferences.layoutConfig.remoteVideoConfig,
      rightSideConfig: (state) => state.preferences.layoutConfig.rightSideConfig,
      partnerLeft: (state) => state.sessionState.partnerLeft,
      partnerDisconnected: (state) => state.sessionState.partnerDisconnected,
      ready: (state) => state.session.ready,
      sessionLoaded: (state) => state.session.sessionLoaded,
    }),
    getRightSideClasses() {
      const config = this.rightSideConfig;
      return getLayoutElementClasses(config, "remoteSide");
    },
    getRemoteVideoClasses() {
      const config = this.remoteVideoConfig;
      return getLayoutElementClasses(config, "remoteVideo");
    },
    getRemoteScreenshareClasses() {
      const config = this.remoteVideoConfig;
      return getLayoutElementClasses(config, "remoteScreenshare");
    },
  },
  methods: {
    rebootWithNewSessionID(SID) {
      this.$emit("rebootWithNewSessionID", SID);
    },
  },
};
</script>

<style scoped>
.partnerCameraOff {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* background-color: #fff9ee; */
  background-color: white;
}

.partnerCameraOffTitle,
.partnerCameraOffText {
  display: flex;
  font-size: 16px;
  width: 100%;
  max-width: 450px;
  margin: 0 auto;
  text-align: center;
  padding: 20px;
  box-sizing: border-box;
  line-height: 24px;
}
.partnerCameraOffTitle {
  font-size: 20px;
  line-height: 28px;
}
@media screen and (max-width: 1200px) {
  .partnerCameraOffTitle {
    font-size: 15px;
    font-weight: 600;
    line-height: 18px;
  }
}
</style>
